import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import classes from "./TabularAdvanceReportPage.module.scss";
import { tabularReport } from "../../../../utils/mainTabs/reports/tabularReport";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import Dropdown from "../../../../components/Common/ReactForm/Dropdown/Dropdown";
import Input from "../../../../components/Common/ReactForm/Input/Input";

import {
  getComprehensiveReportCSVActionHandler,
  getProductCategoryListActionHandler,
  getSearchClassNameActionHandler,
  getSearchUserGroupActionHandler,
  getTabularReportCSVActionHandler,
  getTrainingTypesActionHandler,
  getUserClassCompletionAdvanceReportActionHandler,
  getUserClassCompletionGraphReportActionHandler,
  getUserReportActionHandler,
} from "../../../../store/actions/actionHandlers/reportActionHandler";
import { userAdvanceTabularModalReport } from "../../../../utils/mainTabs/reports/tabularReport/userAdvanceTabularModalReport";
import Modal from "../../../../components/Common/Modal/Modal";
import { useCallback } from "react";
import Button from "../../../../components/Common/Button/Button";
import { useFetchData } from "../../../../hooks/useFetchData";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import WorkOfficeLocationModal from "./WorkOfficeLocationModal";
import { userAdvanceTabularReport } from "../../../../utils/mainTabs/reports/tabularReport/userAdvanceTabularReport";
import moment from "moment";
import ReportGraph from "../../ReportGraph/ReportGraph";
import TreeList from "../../../../components/Common/ReactForm/TreeList/TreeList";
import DownloadIconSmall from "../../../../components/Common/SvgIcons/CommonIcons/DownloadIconSmall";
import apis from "../../../../api";
import { FormattedMessage, injectIntl } from "react-intl";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import InputHookForm from "../../../../components/Common/Input/Input";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const TabularAdvanceReport = ({ intl }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const reportState = useSelector((state) => state.reportReducer);
  const {
    trainingTypes,
    countryList,
    userClassCompletionGraphReport,
    productCategoryList,
    stateList,
    cityList,
    workOfficeList,
    searchClassName,
  } = reportState;

  const chartData = [20, 80];
  const showData = chartData[0] + "%";
  const [trainingTypesOptions, setTrainingTypesOptions] = useState([]);
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);
  let DoughnutChartColors = ["#0b931f", "#2c92de", "#E00000", "#6B6B6B"];
  let TrendChartColors = ["#0b931f", "#ff9933", "#E00000"];
  let completionRatioTotal =
    userClassCompletionGraphReport?.Completed +
    userClassCompletionGraphReport?.InProgress +
    userClassCompletionGraphReport?.NotYetStarted +
    userClassCompletionGraphReport?.Archived;

  let completedRatioPercent = 0;
  if (userClassCompletionGraphReport?.Completed === 0)
    completedRatioPercent = userClassCompletionGraphReport?.Completed;
  else
    completedRatioPercent = Math.round(
      (userClassCompletionGraphReport?.Completed / completionRatioTotal) * 100
    );

  let InProgressRatioPercent = 0;
  if (userClassCompletionGraphReport?.InProgress === 0)
    InProgressRatioPercent = userClassCompletionGraphReport?.InProgress;
  else
    InProgressRatioPercent = Math.round(
      (userClassCompletionGraphReport?.InProgress / completionRatioTotal) * 100
    );

  let NotYetStartedRatioPercent = 0;
  if (userClassCompletionGraphReport?.NotYetStarted === 0)
    NotYetStartedRatioPercent = userClassCompletionGraphReport?.NotYetStarted;
  else
    NotYetStartedRatioPercent = Math.round(
      (userClassCompletionGraphReport?.NotYetStarted / completionRatioTotal) *
        100
    );

  let RecalledRatioPercent = 0;
  if (userClassCompletionGraphReport?.Archived === 0)
    RecalledRatioPercent = userClassCompletionGraphReport?.Archived;
  else
    RecalledRatioPercent = Math.round(
      (userClassCompletionGraphReport?.Archived / completionRatioTotal) * 100
    );

  let completionTrendTotal =
    userClassCompletionGraphReport?.CompletedAfterDeadline +
    userClassCompletionGraphReport?.CompletedInTime +
    userClassCompletionGraphReport?.MissedDeadline;

  let completedInTimePercent = 0;
  if (userClassCompletionGraphReport?.CompletedInTime === 0)
    completedInTimePercent = userClassCompletionGraphReport?.CompletedInTime;
  else
    completedInTimePercent = Math.round(
      (userClassCompletionGraphReport?.CompletedInTime / completionTrendTotal) *
        100
    );

  let completedAfterDeadlinePercent = 0;
  if (userClassCompletionGraphReport?.CompletedAfterDeadline === 0)
    completedAfterDeadlinePercent =
      userClassCompletionGraphReport?.CompletedAfterDeadline;
  else
    completedAfterDeadlinePercent = Math.round(
      (userClassCompletionGraphReport?.CompletedAfterDeadline /
        completionTrendTotal) *
        100
    );

  let MissedDeadlinePercent = 0;
  if (userClassCompletionGraphReport?.MissedDeadline === 0)
    MissedDeadlinePercent = userClassCompletionGraphReport?.MissedDeadline;
  else
    MissedDeadlinePercent = Math.round(
      (userClassCompletionGraphReport?.MissedDeadline / completionTrendTotal) *
        100
    );

  // console.log(
  //   completedRatioPercent,
  //   InProgressRatioPercent,
  //   NotYetStartedRatioPercent,
  //   RecalledRatioPercent
  // );

  // console.log(
  //   completedInTimePercent,
  //   completedAfterDeadlinePercent,
  //   MissedDeadlinePercent
  // );

  var completionTrendOption = {
    plugins: {
      // legend: {
      //   // display: false,
      //   position: "bottom",
      //   borderWidth: 2,
      // },
      legend: {
        position: "bottom",
        display: false,
        labels: {
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;
            return datasets[0].data.map((data, i) => ({
              text: `${chart.data.labels[i]}  ${data}%`,
              fillStyle: datasets[0].backgroundColor[i],
            }));
          },
        },
      },
    },
    cutout: "40%",
  };
  const completionTrendData = {
    labels: [
      "Completed In Time",
      "Completed After Deadlines",
      "Missed Deadlines",
    ],
    datasets: [
      {
        data: [
          completedInTimePercent,
          completedAfterDeadlinePercent,
          MissedDeadlinePercent,
        ],
        backgroundColor: TrendChartColors,
      },
    ],
  };

  // console.log(completionTrendData, "========");

  const completionRatioData = {
    labels: ["Completed", "In-Progress", "Not Started Yet", "Recalled"],
    datasets: [
      {
        data: [
          completedRatioPercent,
          InProgressRatioPercent,
          NotYetStartedRatioPercent,
          RecalledRatioPercent,
        ],
        backgroundColor: DoughnutChartColors,
      },
    ],
  };

  const assesmentScoreData = {
    labels: ["Aggregate Assesment Score"],
    datasets: [
      {
        data: [Math.round(userClassCompletionGraphReport?.AverageQuizScore)],
        backgroundColor: ["#ffcb00"],
      },
    ],
  };

  useEffect(() => {
    const trainingOptions = trainingTypes?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    const product = productCategoryList?.map((d) => ({
      label: d.Name,
      value: d.CategoryId,
    }));
    setProductCategoryOptions(product);
    setTrainingTypesOptions(trainingOptions);
  }, [trainingTypes, productCategoryList]);

  const onTrainingSelected = (e) => {
    setSelctedTraining([e.target.value]);
  };

  const [show, setShow] = useState(false);

  const showModal = () => {
    setShow(true);
  };

  const hideModal = () => {
    setShow(false);
  };

  const pageSize = 20;
  const pageNumber = 1;

  const [selectedCategory, setSelectedCategory] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [selectedTraining, setSelctedTraining] = useState();
  const [categoryId, setCategoryId] = useState(0);
  const [countryId, setCountryId] = useState(0);
  const [stateId, setStateId] = useState(0);
  const [cityId, setCityId] = useState(0);
  const [workOfficeId, setWorkOfficeId] = useState(0);
  const [classId, setClassId] = useState(0);
  const [userLoginId, setUserLoginId] = useState("");
  const [catagoryName, setcatagoryName] = useState("");

  const [userGroupId, setUserGroupId] = useState(0);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedTag, setSelectedTag] = useState("");
  const [selectedUserGroup, setSelectedUserGroup] = useState("");

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setUserClassCompletionReport,
      setTempUserClassCompletionReport,
      setTotalRows
    ) =>
      getUserClassCompletionAdvanceReportActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setUserClassCompletionReport,
        setTempUserClassCompletionReport,
        setTotalRows,
        categoryId,
        cityId,
        classId,
        countryId,
        fromDate,
        stateId,
        toDate,
        workOfficeId,
        selectedTraining,
        userLoginId,
        userGroupId
      ),
    pageSize
  );

  const {
    data: modalData,
    setData: setModalData,
    updatedData: updatedModalData,
    setUpdatedData: setModalUpdatedData,
    totalRows: setModalTotalRows,
    handleCurrentPage: handlerModalCurrentPage,
    handleSearchQuery: handleModalSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setUserClassCompletionReport,
      setTempUserClassCompletionReport,
      setTotalRows
    ) =>
      getUserReportActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setUserClassCompletionReport,
        setTempUserClassCompletionReport,
        setTotalRows,
        categoryId,
        cityId,
        classId,
        countryId,
        fromDate,
        stateId,
        toDate,
        workOfficeId,
        selectedTraining,
        userId,
        userGroupId
      ),
    pageSize
  );

  useEffect(() => {
    const trainingOptions = trainingTypes?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));

    setTrainingTypesOptions(trainingOptions);
  }, [trainingTypes]);

  useEffect(() => {
    // dispatch(getCountryListActionHandler());
    dispatch(getTrainingTypesActionHandler());
    dispatch(getProductCategoryListActionHandler());
  }, [dispatch]);

  const handleDepartmentClick = () => {
    dispatch(getProductCategoryListActionHandler());
  };

  const [userId, setUserId] = useState(0);

  const { columns } = userAdvanceTabularReport;
  const handleUserPopUp = useCallback((userId) => {
    setUserId(userId);
    handleModalSearchQuery("");
  }, []);

  let className;

  modalData?.map((i) => {
    if (i.UserId === userId) {
      className = i.ClassName;
    }
  });

  const handleUserClassData = () => {
    handleUserPopUp(0);
  };

  const [tableColumns, setTableColumns] = useState([]);
  useEffect(() => {
    let newTableColumns = columns(navigate, handleUserPopUp);
    setTableColumns(newTableColumns);
  }, [columns, navigate, handleUserPopUp]);

  const { columns: modalColumns } = userAdvanceTabularModalReport;

  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [productCategory, setProductCategory] = useState("");

  const [searchClassTagsList, setSearchClassTagsList] = useState([]);

  const [searchGroupTagsList, setSearchGroupTagsList] = useState([]);

  const onClassSearch = useCallback(
    (e) => {
      // console.log(e.target.value, "++++++++");
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        dispatch(
          getSearchClassNameActionHandler(
            e.target.value,
            setSearchClassTagsList
          )
        );
      } else {
        setSearchClassTagsList([]);
      }
    },
    [dispatch, setSearchClassTagsList]
  );
  const onUserGroupSearch = useCallback(
    (e) => {
      // console.log(e.target.value, "++++++++");
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        dispatch(
          getSearchUserGroupActionHandler(
            e.target.value,
            setSearchGroupTagsList
          )
        );
      } else {
        setSearchGroupTagsList([]);
      }
    },
    [dispatch]
  );

  const [selectedLocationValue, setSelectedLocationValue] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState([]);

  //  const [fromDate, setFromDate] = useState(moment().format("DD-MM-YYYY"));
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const onFromDateChange = (date) => {
    setFromDateValue(date.target.value);
    const newDate = moment(date.target.value).format("DD/MM/YYYY");
    // setFromDate(new Date(date.target.value).toLocaleDateString());
    setFromDate(encodeURIComponent(newDate) + encodeURI("+"));
  };

  const onToDateChange = (date) => {
    setToDateValue(date.target.value);
    const newDate = moment(date.target.value).format("DD/MM/YYYY");
    // setToDate(new Date(date.target.value).toLocaleDateString());

    setToDate(encodeURI("+") + encodeURIComponent(newDate));
  };

  const handleReset = (date) => {
    setSelctedTraining("0");
    setFromDate(date);
    setToDate("");
    reset();
    setSelectedLocationValue("");
    setFromDateValue("");
    setToDateValue("");
    setFromDate(moment().format("dd-mm-yyyy"));
    setIsSubmitted(false);
    setSelectedTag([]);
    setcatagoryName([]);
    setSelectedUserGroup("");

    //mukesh
    setSelectedTag("");
    setClassId("");
    setSearchClassTagsList([]);
  };
  console.log(selectedTag, "selectedTag");
  console.log(classId, "classId");
  console.log(searchClassTagsList, "searchClassTagsList");
  
  const onFilterSearch = () => {
    if (classId) {
      setIsSubmitted(true);
      dispatch(
        getUserClassCompletionGraphReportActionHandler(
          categoryId,
          cityId,
          classId,
          countryId,
          fromDate,
          pageNumber,
          pageSize,
          stateId,
          toDate,
          workOfficeId,
          selectedTraining,
          userLoginId,
          userGroupId
        )
      );

      handleSearchQuery("");
    } else {
      dispatch(setErrorHandler(errorTypes.WARN, "Please select class name!"));
    }
  };

  const handleClick = () => {
    dispatch(
      getUserClassCompletionAdvanceReportActionHandler(
        "",
        pageNumber,
        pageSize,
        "",
        "",
        "",
        categoryId,
        cityId,
        classId,
        countryId,
        fromDate,
        stateId,
        toDate,
        workOfficeId,
        selectedTraining,
        userLoginId,
        userGroupId
      )
    );
  };

  const handleComprehensiveReportDownload = () => {
    dispatch(
      getComprehensiveReportCSVActionHandler(
        userLoginId,
        userGroupId,
        classId,
        selectedTraining,
        categoryId,
        fromDate,
        toDate,
        countryId,
        stateId,
        cityId,
        workOfficeId
      )
    );
  };
  const handleTabularReportDownload = () => {
    dispatch(
      getTabularReportCSVActionHandler(
        userLoginId,
        userGroupId,
        classId,
        selectedTraining,
        categoryId,
        fromDate,
        toDate,
        countryId,
        stateId,
        cityId,
        workOfficeId
      )
    );
  };
  // mukesh training types
  const methods = useForm({
    mode: "onChange",
    // resolver: yupResolver(graphicalReportSchema),
  });
  const {
    formState: { errors },
    reset,
    getValues,
  } = methods;
  const [searchTrainingTypeList, setSearchTrainingTypeList] = useState([]);
  useEffect(() => {
    if (trainingTypes?.length > 0) {
      const updatedTrainingTypes = trainingTypes?.map((trainingType) => {
        return { ...trainingType, isVisible: true };
      });
      setSearchTrainingTypeList(updatedTrainingTypes);
    }
  }, [trainingTypes, setSearchTrainingTypeList]);
  const handleTrainingClick = (e) => {
    const detailsData = getValues();
    setSelctedTraining(detailsData.TrainingType[0].TypeId);
  };
  const handleModalDownloadCSV = () => {
    dispatch(
      getComprehensiveReportCSVActionHandler(
        userId,
        userGroupId,
        classId,
        selectedTraining,
        categoryId,
        fromDate,
        toDate,
        countryId,
        stateId,
        cityId,
        workOfficeId
      )
    );
  };
  return (
    <>
      <div className={classes.reportFilter_userClass}>
        <div className={classes.reportFilter_userClass_Input}>
          <Input
            label={<FormattedMessage id="CLASS_NAME_TEXT" />}
            placeholder={intl.formatMessage({
              id: `REPORT_PLACEHOLDER_CLASSNAME`,
            })}
            // width="31.9"
            type="tags"
            fieldValue={"ID"}
            setSelectedId={setClassId}
            onChange={(e) => onClassSearch(e)}
            searchTagsList={searchClassTagsList}
            setSelectedTag={setSelectedTag}
            selectedTag={selectedTag}
          />

          <Input
            label={"From Date"}
            type={"date"}
            isFromDate
            value={fromDateValue}
            onChange={onFromDateChange}
          />
          <Input
            label={"To Date"}
            type={"date"}
            min={fromDate}
            value={toDateValue}
            onChange={onToDateChange}
          />
          {/* <Dropdown
            label={<FormattedMessage id="TRAINING_TYPE" />}
            defaultValue={selectedTraining}
            placeholder={intl.formatMessage({
              id: `SHOTCLASSES_ANALYTICAL_REPORT_TRAINING_TYPE`,
            })}
            options={trainingTypesOptions}
            onChange={(e) => setSelctedTraining(e.target.value)}
            selectedValue={selectedTraining}
          /> */}
          <FormProvider {...methods}>
            <InputHookForm
              label={<FormattedMessage id="TRAINING_TYPE" />}
              labelColor="dark"
              name="TrainingType"
              fieldName="Name"
              fieldValue="TypeId"
              type="noSearchTags"
              tagType="single"
              buttonLabel="Search Training Type"
              placeholder="Search Training Type"
              // error={errors.TrainingType?.message}
              // valueArr={trainingTypes}
              searchTagsList={searchTrainingTypeList}
              handleTagList={(tagsList) => {
                setSearchTrainingTypeList(tagsList);
              }}
              height="4"
              searchable={true}
              disabled={false}
              isTagCheckBoxVisible={false}
              addedTagsVisible={false}
              onChange={handleTrainingClick}
              width={"25"}
            />
          </FormProvider>
        </div>

        <div className={classes.reportFilter_userClass_Input}>
          <Input
            type="tags"
            label={<FormattedMessage id="REPORT_USERGRP_TXT" />}
            placeholder="Enter User Group"
            width="31.9"
            fieldValue={"UserGroupId"}
            setSelectedId={setUserGroupId}
            onChange={(e) => onUserGroupSearch(e)}
            searchTagsList={searchGroupTagsList}
            setSelectedTag={setSelectedUserGroup}
            selectedTag={selectedUserGroup}
          />
          <Input
            type={"text"}
            label={<FormattedMessage id="REPORT_ENTERLOCATION_TXT" />}
            placeholder={intl.formatMessage({
              id: `MY_PROFILE_WORK`,
            })}
            onClick={showModal}
            value={selectedLocationValue}
            width="31.9"
          />

          {show && (
            <WorkOfficeLocationModal
              show={show}
              setShow={setShow}
              setSelectedLocationValue={setSelectedLocationValue}
              // setSelectedLocationId={setSelectedLocationId}
              setCountryId={setCountryId}
              setStateId={setStateId}
              setCityId={setCityId}
              setWorkOfficeId={setWorkOfficeId}
            />
          )}
          {/* <Dropdown
            label={"User Department"}
            width="31.9"
            defaultValue={productCategory}
            placeholder="User Department"
            options={productCategoryOptions}
            onChange={(e) => setProductCategory(e.target.value)}
            selectedValue={productCategory}
          /> */}
          <TreeList
            placeholder={intl.formatMessage({
              id: `DIST_HISTORY_CATEGORY`,
            })}
            label={<FormattedMessage id="REPORT_USER_CATEROTY" />}
            productCategory={productCategoryList}
            setCategoryId={setCategoryId}
            setcatagoryName={setcatagoryName}
            catagoryName={catagoryName}
          />
        </div>
        <div
          style={{
            display: "flex",
            paddingTop: 15 + "px",
            alignItems: "center",
          }}
        >
          <div
            className={classes.download}
            onClick={handleComprehensiveReportDownload}
          >
            <div className={classes.downloadIcon}>
              <DownloadIconSmall />
            </div>
            {<FormattedMessage id="DWNLD_COMPREHENSIVE_REPORT" />}
          </div>
          <div className={classes.searchResetButton}>
            <span
              style={{
                textDecoration: "underline",
                color: "#0051BC",
                cursor: "pointer",
                paddingTop: "12px",
              }}
              onClick={handleReset}
            >
              <FormattedMessage id="Report_Reset_btn" />
            </span>
            <Button
              label={<FormattedMessage id="Report_Search_btn" />}
              dark
              small
              className={classes.searchButton}
              onClick={onFilterSearch}
            />
          </div>
        </div>
      </div>
      {isSubmitted ? (
        <>
          <div className={classes.graphicalReport_mainLayout}>
            <div className={classes.graphicalReport_doughnut_main}>
              <div className={classes.graphicalReport_doughnut}>
                <ReportGraph
                  type={"doughnut"}
                  graphData={assesmentScoreData}
                  heading={
                    <FormattedMessage id="REPORT_AGGREGATEASSESSMENTSCORE_TXT" />
                  }
                  totalPercentage={Math.round(
                    userClassCompletionGraphReport?.AverageQuizScore
                  )}
                />
              </div>
              <div className={classes.graphicalReport_doughnut}>
                <ReportGraph
                  type={"doughnut"}
                  graphData={completionRatioData}
                  heading={<FormattedMessage id="REPORT_COMPLETIONRATIO_TXT" />}
                  totalPercentage={completionRatioTotal}
                />
              </div>
              <div className={classes.graphicalReport_doughnut}>
                <ReportGraph
                  type={"doughnut"}
                  graphData={completionTrendData}
                  totalPercentage={completionTrendTotal}
                  heading={<FormattedMessage id="REPORT_COMPLETIONTREND_TXT" />}
                />
              </div>
            </div>
          </div>
          <div className={classes.tabularDataTable}>
            <DataTable
              // columns={columns(navigate, handleUserPopUp)}
              columns={tableColumns}
              defaultData={data}
              setDefaultData={setData}
              data={updatedData}
              setData={setUpdatedData}
              totalRows={totalRows}
              downloadable
              onDownload={handleTabularReportDownload}
              uniqueFieldName={"UserId"}
              fetchMoreData={handleCurrentPage}
            />
            <Modal
              handleSubmit={handleUserClassData}
              isOpen={userId}
              heading={"User Report Details"}
              toggle={() => handleUserPopUp()}
              height={"60"}
            >
              <div>
                {/* <div className={classes.mainHeadingModal}>
                  <h3>User Name:</h3>{" "}
                  <p className={classes.userName}>{userName}</p>
                  <h3>User Group Association:</h3>{" "}
                  <p className={classes.userName}>{userName}</p>
                </div> */}
                {modalData?.map((e) => {
                  return (
                    <div>
                      <div>
                        <b>
                          <FormattedMessage id="USER_NAME_TEXT" />:{" "}
                        </b>
                        {e.FirstName + " " + e.LastName}
                        <br />
                        <b>
                          <FormattedMessage id="REPORT_USER_GROUP_ASSOCIATION" />
                          :{" "}
                        </b>
                        {e.Usergroup}
                        <br />
                        <b>
                          <FormattedMessage id="REPORT_USER_CATEROTY" />:{" "}
                        </b>
                        {e.Category ? e.Category : "none"}
                        <br />
                        <b>
                          <FormattedMessage id="REPORT_WORK_LOCATION" />:{" "}
                        </b>
                        {e.WorkLocation ? e.WorkLocation : "none"}
                      </div>
                    </div>
                  );
                })}
                <div>
                  <h2>
                    <FormattedMessage id="CLASS_NAME_TEXT" />: {className}
                  </h2>
                </div>
                <DataTable
                  columns={modalColumns(navigate)}
                  // defaultData={data}
                  // setDefaultData={setData}
                  data={modalData}
                  // setData={setUpdatedData}
                  totalRows={setModalTotalRows}
                  uniqueFieldName={"ClassName"}
                  fetchMoreData={handlerModalCurrentPage}
                  downloadable
                  onDownload={handleModalDownloadCSV}
                />
              </div>
            </Modal>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default injectIntl(TabularAdvanceReport);
